import {createWebHistory, createRouter} from "vue-router";
import store from 'store'
import auth from 'middleware/auth'

const baseURL = process.env.VUE_APP_BASE_URL;

export const routes = [
    {
        name: 'home',
        path: baseURL,
        redirect: baseURL + 'wizard',
        meta: {},
    },
    {
        name: 'wizard',
        path: baseURL + 'wizard',
        meta: {
            layout: 'wizard'
        },
        component: () => import('../pages/WizardPage.vue')
    },
    {
        name: 'hotel',
        path: baseURL + 'wizard/hotel/:hotelId/:roomId/:mealId/:htplaceId/:ratePlan',
        meta: {
            
        },
        component: () => import('../pages/HotelPage.vue')
    },
    {
        name: 'status',
        path: baseURL + 'status/:key',
        component: () => import('../pages/StatusPage.vue')
    },
    {
        name: 'activate',
        path: baseURL + 'activate',
        component: () => import('../pages/ActivatePage.vue')
    },
    {
        name: 'claims',
        path: baseURL + 'claims',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/ClaimsPage.vue')
    },
    {
        name: 'myClaims',
        path: baseURL + 'my-claims',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/MyClaimsPage.vue')
    },
    {
        name: 'reports',
        path: baseURL + 'reports',
        redirect: baseURL + 'reports/spo-list-report',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/SpoListReportPage.vue')
    },
    {
        name: 'spoListReport',
        path: baseURL + 'reports/spo-list-report',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/SpoListReportPage.vue')
    },
    {
        name: 'spoPriceReport',
        path: baseURL + 'reports/spo-price-report',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/SpoPriceReportPage.vue')
    },
    {
        name: 'stopsaleReport',
        path: baseURL + 'reports/stopsale-report',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/StopsaleReportPage.vue')
    },
    {
        name: 'messages',
        path: baseURL + 'messages',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/MessagesPage.vue')
    },
    {
        name: 'postpone',
        path: baseURL + 'postpone',
        meta: {
            middleware: [
                auth
            ]
        },
        component: () => import('../pages/PostponePage.vue')
    },
    {
        name: 'widgets',
        path: baseURL + 'widgets',
        meta: {},
        component: () => import('../pages/WidgetsPage.vue')
    },
    {
        name: 'aboutRu',
        path: baseURL + 'about-ru',
        meta: {},
        component: () => import('../pages/AboutPageRu.vue')
    },
    {
        name: 'aboutEn',
        path: baseURL + 'about-en',
        meta: {},
        component: () => import('../pages/AboutPageEn.vue')
    },
    {
        name: 'demo',
        path: baseURL + 'demo',
        meta: {},
        component: () => import('../pages/DemoPage.vue')
    },
    {
        name: 'pay',
        path: baseURL + 'pay',
        component: () => import('../pages/PayPage.vue')
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: routes
});

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next()
    }
    const middleware = to.meta.middleware
    const context = {
        to,
        from,
        next,
        store
    }
    return middleware[0]({
        ...context
    })
})

export default router
